import React, {useEffect} from 'react';

import MaterialTable from "material-table";

import AddBox from '@material-ui/icons/AddBox';
import ArrowUpward from '@material-ui/icons/ArrowUpward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import Typography from "@material-ui/core/Typography/Typography";
import {useDispatch, useSelector} from "react-redux";
import {getMetas} from "../../../actions/i4Actions";

const tableIcons = {
    Add: AddBox,
    Check: Check,
    Clear: Clear,
    Delete: DeleteOutline,
    DetailPanel: ChevronRight,
    Edit: Edit,
    Export: SaveAlt,
    Filter: FilterList,
    FirstPage: FirstPage,
    LastPage: LastPage,
    NextPage: ChevronRight,
    PreviousPage: ChevronLeft,
    ResetSearch: Clear,
    Search: Search,
    SortArrow: ArrowUpward,
    ThirdStateCheck: Remove,
    ViewColumn: ViewColumn
};



const MetasTabela = (props) => {
    const metas = useSelector( st => st.i4.metas);

    const dispatch = useDispatch();

    useEffect( () => {
        dispatch(getMetas());
    }, []);




    console.log("metas", metas);


    const labelCategoriaMeta = (rd) => {
        let lb = "--";
        switch(rd.metaCategoriaId) {
            case 1:
                lb = "RECAPADOS";
                break;
            case 3:
                lb = "RECUSA/REPROVA";
                break;
        }
        return (<Typography>{lb}</Typography>)
    }

    const getColumns = () => {
        return [
            {
                title: 'id',
                field: 'id',
                editable: 'never',
                hidden: true
            },
            {
                title: 'Ano',
                field: 'ano',
                //render: rowData => <Typography >{convertISODateTimeToTz(rowData.data).substring(0,10)}</Typography>,
                editable: 'never',
            },
            {
                title: 'Mês',
                field: 'mes',
                editable: 'never',
            },
            {
                title: 'Estabelecimento',
                field: 'estabelecimentoId',
               // render: rowData => {return labelProducao(rowData)},
                editable: 'never',
            },
            {
                title: 'Turno',
                field: 'turno',
                editable: 'never',
                //   render: rowData => {return labelEquipamentos(rowData)},

            },
            {
                title: 'Dias Uteis',
                field: 'diasUteis',
                editable: 'never',
              //  render: rowData => {return labelPneus(rowData)},

            },

            {
                title: 'Categoria Meta',
                field: 'metaCategoriaId',
                editable: 'never',
                render: rowData => {return labelCategoriaMeta(rowData)},

            },
            {
                title: 'Objetivo',
                field: 'objetivo',
                editable: 'never',
             //    render: rowData => {return labelPessoal(rowData)},

            }



        ];
    }

        return (
            <React.Fragment>


                        <MaterialTable
                            icons={tableIcons}
                            title="Metas"
                            columns={getColumns()}
                            data={metas}
                            onRowClick= {(event,  rowData) => {
                                    props.openDialog(true,rowData);
                            }}
                            actions={[
                                // {
                                //     icon: 'add',
                                //     tooltip: 'Novo Meta',
                                //     isFreeAction: true,
                                //     onClick: (event) => {
                                //           props.openDialog(true, null);
                                //          }
                                // }
                            ]}

                            options={{
                                filtering: true,
                                pageSize: 15,
                                pageSizeOptions: [10,15,25],
                                addRowPosition: 'first'
                            }}



                        />


            </React.Fragment>
        );

}

export default MetasTabela;

